import {useTranslation} from 'react-i18next';
import * as css from './TimetableSalesHeader.css';
import TimetableToolbar from '../../../../../../timetable/components/timetableToolbar/TimetableToolbar';
import LinkIcon from '../../../../../../../assets/icons/LinkIcon';

function TimetableSalesHeader({eid}: {eid: number}) {
    const {t} = useTranslation('realtime');

    return (
        <css.header>
            <css.title>{t('lectures')}</css.title>
            <css.controls>
                <css.toolbar>
                    <TimetableToolbar controlled />
                </css.toolbar>
                <css.manageBtn to={`/e/${eid}/timetable`}>
                    <LinkIcon color="currentColor" />
                    {t('manageTimetable')}
                </css.manageBtn>
            </css.controls>
        </css.header>
    );
}
export default TimetableSalesHeader;
